<div class="chat-container">
  <div [ngClass]="{ 'no-messages': messages.length === 0 && !state.loading }">
    <div class="nb-card-header">
      <div>{{name}}</div>
    </div>
      <ng-container *ngIf="messages.length > 0;else noMessages">
        <ng-container *ngIf="anyCategorySelected$ | async;else noSelections">
          <div class="assistant-info">
            <p>Edit the input to regenerate the tree.</p>
          </div>
        </ng-container>
        <ng-template #noSelections>
          <div class="assistant-info">
            <p>Tick the categories you'd like to have in your catalog. Or enter more product types to generate a new tree.</p>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #noMessages>
        <div class="no-messages">
          <p>{{ assistantDescription }}</p>
        </div>
      </ng-template>
    
  </div>
  <ng-container *ngIf="messages.length >0">
    <div class="message-flow">
      <div class="catalog-tree">
        <ng-container *ngFor="let node of nodes">
          <ubs-catalog-node [node]="node" (select)="selectCategory($event)"></ubs-catalog-node>
        </ng-container>
        <!-- <ng-container *ngFor="let message of messages">
          <ng-container *ngFor="let content of message.content">
            <ng-container *ngFor="let node of content.children">
              <ubs-catalog-node [node]="content" (select)="selectCategory($event)"></ubs-catalog-node>
            </ng-container>
          </ng-container>
        </ng-container> -->
      </div>
    </div>
    
  </ng-container>
  <div class="input-section">
    <!-- Button only appears if any node is selected -->
     <div class="centered-button">
      <button nbButton size="small" *ngIf="anyCategorySelected$ | async" (click)="createAcceptedCatalog()">
        Accept Selections
      </button>
     </div>
    
    <ubs-input-panel
      [currentStep]="state?.currentStep"
      [isLoading]="state?.loading"
      [hasMessages]="hasMessages$ | async"
      [hasSelections]="hasSelections$ | async"
      (textSubmit)="handleTextInput($event)"
      (productListSubmit)="handleTextInput($event)"
      [ngClass]="{ 'no-messages': !(hasMessages$ | async) || !(hasSelections$ | async)}">
    </ubs-input-panel>
    <!-- <ubs-input-panel
      [currentStep]="state?.currentStep"
      [isLoading]="state?.loading"
      (textSubmit)="handleTextInput($event)"
      (productListSubmit)="handleTextInput($event)">
    </ubs-input-panel> -->
  </div> 
</div>

  
